const items = [{
  name: "تست",
  printType: "test",
  printData: null
}, {
  name: "کد QR",
  printType: "tableQrCode",
  printData: {
    subdomain: "subdomain",
    domain: "domain",
    qrCodeExpiryTime: 30,
    tableName: "1"
  }
}, {
  name: "شیفت",
  printType: "shift",
  printData: {
    fullName: "سام",
    mobilePhone: "09351234567",
    actualCashAmount: 1357000,
    charges: 90000,
    date: "2024-09-10T20:57:38.163Z",
    diffrence: 55000,
    discounts: 8000,
    endAt: "2024-09-10T20:57:39.191Z",
    paidIns: [],
    paidOuts: [],
    payments: {
      card: 100000,
      cash: 1357000,
      credit: 20000,
      others: 30000
    },
    refund: 50000,
    startAt: "2024-09-08T16:10:21.126Z",
    startingCash: 8000,
    taxes: 10000
  }
}, {
  name: "تغییر میز",
  printType: "tableMoved",
  printData: {
    date: "2024-09-10T21:05:31.977Z",
    destinationTableNumber: "9",
    movedOrderCodes: [100, 200, 300, 400],
    originTableNumber: "7",
  }
}, {
  name: "رسید مشتری (pos)",
  printType: "order",
  printData: {
    code: 1,
    note: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. ",
    kitchenTitle: "نام فروشگاه",
    customerFullName: "sam",
    customerMobilePhone: "+989351234567",
    subdomain: "subdomain",
    domain: "domain",
    date: "2024-09-10T21:00:53.193Z",
    deliveryFee: 0,
    deliveryService: "",
    branchName: "شعبه",
    branchAddress: "آدرس",
    branchContactNumber: "021********",
    address: {
      _id: "674c7ca5f65fbb8748901e5a",
      contractId: "674c5a653b004ee03dd18a88",
      accountId: "674c7bae8c03c3543d08fb43",
      areaName: "قیمت ثابت پست",
      address: "تهران، مدنی، حسینی نژاد، قربانعلی پور",
      city: "شهر",
      state: "استان",
      zipCode: "1234",
      country: "ایران",
      location: {
        type: "Point",
        coordinates: [
          48.4910201,
          34.8039071
        ]
      },
      verified: false,
      isDeleted: false,
      deletedAt: null,
      __v: 0
    },
    deliveryType: "delivery",
    items: [{
      foodName: "کالا 2",
      isSimple: false,
      optionName: "مدل",
      quantity: 1,
      salePrice: 120000,
      specificationItems: [{
        createdAt: "2024-08-11T13:24:11.448Z",
        isAvailable: true,
        name: "آپشن 2",
        salePrice: 0,
        updatedAt: "2024-08-11T13:24:11.448Z",
        _id: "66b8bb7b5e43c2ae69bba637"
      }, {
        createdAt: "2024-08-11T13:24:41.591Z",
        isAvailable: true,
        name: "افزودنی 1",
        salePrice: 2000,
        updatedAt: "2024-08-11T13:24:41.591Z",
        _id: "66b8bb995e43c2ae69bba65b"
      }],
      systemDiscount: 6000,
      taxItems: [],
    }],
    thisPrinterOrderItems: [{
      foodName: "کالا 2",
      isSimple: false,
      optionName: "مدل",
      quantity: 1,
      salePrice: 120000,
      specificationItems: [{
        createdAt: "2024-08-11T13:24:11.448Z",
        isAvailable: true,
        name: "آپشن 2",
        salePrice: 0,
        updatedAt: "2024-08-11T13:24:11.448Z",
        _id: "66b8bb7b5e43c2ae69bba637"
      }, {
        createdAt: "2024-08-11T13:24:41.591Z",
        isAvailable: true,
        name: "افزودنی 1",
        salePrice: 2000,
        updatedAt: "2024-08-11T13:24:41.591Z",
        _id: "66b8bb995e43c2ae69bba65b"
      }],
      systemDiscount: 6000,
      taxItems: []
    }, {
      foodName: "پیتزا",
      isSimple: false,
      optionName: "مدل",
      quantity: 1,
      salePrice: 120000,
      specificationItems: [{
        createdAt: "2024-08-11T13:24:11.448Z",
        isAvailable: true,
        name: "آپشن 2",
        salePrice: 0,
        updatedAt: "2024-08-11T13:24:11.448Z",
        _id: "66b8bb7b5e43c2ae69bba637"
      }, {
        createdAt: "2024-08-11T13:24:41.591Z",
        isAvailable: true,
        name: "افزودنی 1",
        salePrice: 2000,
        updatedAt: "2024-08-11T13:24:41.591Z",
        _id: "66b8bb995e43c2ae69bba65b"
      }],
      systemDiscount: 6000,
      taxItems: []
    }],
    printCustomerReceipt: true,
    printKitchenReceipt: true,
    queueNumber: "3",
    orderStatus: "pending",
    subtotal: 122000,
    tableNumber: "7",
    taxesAndCharges: [],
    total: 116000,
    totalBeforeDiscount: 122000,
    totalDeliveryDiscountByCoupon: 0,
    totalFoodDiscounts: 6000,
    totalSystemDiscounts: 6000,
    _id: "c0dda0b0-f014-45ce-b1c7-86754b860414"
  }
}, {
  name: "ترکیب سفارش",
  printType: "combinedOrder",
  printData: {
    tableNumber: "12",
    combinedOrderCodes: ["100", "30", "40"]
  }
}, {
  name: "حذف سفارش",
  printType: "deletedOrder",
  printData: {
    accountRole: "access",
    code: 100,
    customerFullName: "sam",
    date: "2024-09-10T21:00:53.172Z",
    deliveryService: "internal",
    deliveryType: "dineIn",
    items: [{
      deliveryDiscount: 0,
      deliveryFee: 0,
      extraFoodIds: [],
      foodCode: 2,
      salePrice: 120000,
      quantity: 2,
      foodDiscount: 0,
      foodId: "667d5452779c1c8fc8d38dff",
      foodImageCover: "https://api.caspian-bazar.ir/storage/image/LXVXNHBPFOOD585180179136484.jpeg",
      foodName: "کالا 2",
      isSimple: false,
      option: { _id: "667d5452779c1c8fc8d38e00", name: "مدل", salePrice: 120000 },
      orderItemSpecifications: [{
        groupName: "گروه 1",
        isAddOn: false,
        isRequired: false,
        maxQuantity: 0,
        specificationId: "66b8bb7b5e43c2ae69bba630",
        specificationItems: [{
          isAvailable: true,
          name: "آپشن 1",
          salePrice: 0,
          specificationItemId: "66b8bb995e43c2ae69bba65b",
        }]
      }, {
        groupName: "گروه 2",
        isAddOn: true,
        isRequired: false,
        maxQuantity: 0,
        specificationId: "66b8bb995e43c2ae69bba653",
        specificationItems: [{
          isAvailable: true,
          name: "افزودنی 1",
          salePrice: 2000,
          specificationItemId: "66b8bb995e43c2ae69bba65b",
        }]
      }],
      specificationItemIds: [
        "66b8bb7b5e43c2ae69bba637",
        "66b8bb995e43c2ae69bba65b"
      ],
      systemDiscount: 6000,
      taxInclusive: true,
      taxItems: [],
      totalBillAmount: 116000,
      totalBillAmountBeforeDiscount: 122000,
      totalBillAmountBeforeTax: 116000,
      totalSpecificationSalePrice: 2000,
      _id: "66e0b3845435a81861e95af5"
    }],
    tableNumber: "9"
  }
}, {
  name: "ویرایش سفارش",
  printType: "orderEdited",
  printData: {
    kitchenTitle: "نام فروشگاه",
    tableNumber: "1",
    orderId: "66e0b3845435a81861e95af4",
    date: "2024-09-10T21:05:30.949Z",
    code: 100,
    orderTempId: "8",
    qrCodeTag: "asdq1",
    changedCombos: [{
      code: "utlfp14na",
      comboDiscount: -735000,
      comboSetSalePrice: 1000000,
      groupNumber: 2,
      isBuyxFreeX: undefined,
      name: "تست",
      sortNumber: 1727617154971,
      items: [{
        addAmount: 0,
        comboSetId: undefined,
        comboSetItemId: "66a4f6f73b157fc4a221f17c",
        foodCode: 2,
        foodDiscount: 0,
        foodId: "667d5452779c1c8fc8d38dff",
        foodImageCover: "https://api.caspian-bazar.ir/storage/image/LXVXNHBPFOOD585180179136484.jpeg",
        foodName: "کالا 1",
        isSimple: false,
        option: { _id: "667d5452779c1c8fc8d38e00", name: "مدل", salePrice: 120000 },
        optionId: "667d5452779c1c8fc2d38e00",
        optionName: "مدل",
        orderItemId: "66f95799641bb305a5dd7420",
        orderItemSpecifications: [],
        quantity: 1,
        salePrice: 120000,
        taxInclusive: true,
        taxItems: []
      }]
    }],
    changedItems: [{
      code: 2,
      foodId: "667d5452779c1c8fc8d38dff",
      foodImageCover: "https://api.caspian-bazar.ir/storage/image/LXVXNHBPFOOD585180179136484.jpeg",
      foodName: "کالا 2",
      isSimple: false,
      onlyThisDeliveries: [],
      optionId: "667d5452779c1c8fc8d38e00",
      optionName: "مدل",
      orderItemId: "66f95799641bb505a5dd7422",
      quantity: 1,
      salePrice: 120000,
      systemDiscount: 0,
      taxInclusive: true,
      taxItems: [],
      specificationItems: [{
        isAvailable: true,
        name: "آپشن 2",
        salePrice: 0,
        specificationItemId: "66b8bb7b5e43c2ae69bba637",
        _id: "66b8bb7b5e43c2ae69bba637",
      }, {
        isAvailable: true,
        name: "افزودنی 1",
        salePrice: 10000,
        specificationItemId: "66b8bb995e43c2ae69bba656",
        _id: "66b8bb995e43c2ae69bba656"
      }]
    }]
  }
}]

export default items